// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import categoryNameStyles from "@guestsupply/App/SharedStyles/CategoryNameStyles";
import { productCountStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListProductCount";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const textSharedStyles: TypographyPresentationProps = {
    variant: "h5",
    css: css`
        white-space: nowrap;
        margin-bottom: 0;
    `,
};

productCountStyles.wrapper = {
    css: css`
        margin-top: 0;
        display: flex;
        ${xScreen("lte", "md")} {
            justify-content: flex-end;
        }
    `,
};
productCountStyles.countText = {
    ...textSharedStyles,
};
productCountStyles.itemsText = {
    ...mergeWithCss(textSharedStyles, {
        css: css`
            margin-left: 4px;
        `,
    }),
};
productCountStyles.queryText = {
    ...mergeWithCss(textSharedStyles, {
        css: css`
            margin-left: 4px;
        `,
    }),
};

productCountStyles.titleWrapper = {
    ...categoryNameStyles.categoryTitleWrapper,
};
productCountStyles.categoryName = {
    ...categoryNameStyles.categoryName,
};
